import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {PageNames} from '../../page-names.enum';
import {TvShopEntertainmentPack} from '../../../model/tv-shop-entertainment-pack';
import {OrderOption} from '../../../model/order-option';
import {PriceDetail} from '../../../model/ocapi/price-detail';
import {LanguageService} from '../../../services/language/language.service';
import {Order} from '../../../model/order';
import {PriceUtils} from '../../utils/price/price.utils';
import {ImageUtils} from '../../utils/image/image-utils';
import {Price} from "../../../model/ocapi/price";

@Component({
  selector: 'app-pack-option',
  templateUrl: './pack-option.component.html',
  styleUrls: ['./pack-option.component.less']
})
export class PackOptionComponent implements OnInit {
  ownerComponent = PageNames.PACK_OPTION_SELECTION;
  @Input() x: number;
  @Input() y: number;
  @Input() omapiId: string;
  @Input() pack: TvShopEntertainmentPack;
  @Input() orderOption: OrderOption;
  @Input() badgeCopyKey: string;

  @Output() emitOrderProduct = new EventEmitter<Object>();
  @Output() emitOnBack = new EventEmitter<Object>();

  active: boolean;
  name: string;
  priceDetail: PriceDetail;

  constructor(private languageService: LanguageService) {
  }

  ngOnInit(): void {
    this.priceDetail = this.orderOption ? this.orderOption.priceDetail : undefined;
  }

  activate(active: boolean): void {
    this.active = active;
  }

  get hasPromo(): boolean {
    return this.orderOption.priceDetail && this.orderOption.priceDetail.promoDuration > 0;
  }

  get hasDiscount(): boolean {
    if (this.orderOption.term) {
      return !!this.orderOption.discount;
    }
  }

  get textIntegerPart(): string {
    let promoPrice;
    if (this.hasPromo && !this.hasDiscount) {
      promoPrice = this.orderOption.priceDetail.promoPrice.integerPart();
      return promoPrice;
    }

    promoPrice = this.orderOption.priceDetail.price.value;
    if (this.orderOption.discount) {
      promoPrice += this.orderOption.discount;
    }
    return new Price(promoPrice).integerPartNumber().toString();
  }

  get textDecimalPart(): string {
    let price;

    if (this.hasPromo && !this.hasDiscount) {
      price = this.orderOption.priceDetail.promoPrice.decimalPart();
      return this.getTextDecimalPart(price);
    }

    price = this.orderOption.priceDetail.price.value;
    if (this.orderOption.discount) {
      price += this.orderOption.discount;
    }
    return this.getTextDecimalPart(new Price(price.toFixed(2)).decimalPart());
  }

  get textIntegerPartOriginal(): string {
    return this.orderOption.priceDetail.price.integerPart();
  }

  get textDecimalPartOriginal(): string {
    return this.getTextDecimalPart(this.orderOption.priceDetail ? this.orderOption.priceDetail.price.decimalPart() : undefined);
  }

  get packOptionLogoUrl(): string {
    const componentName = this.orderOption.name + '-' + this.getCurrentLang + '-pack-option';
    return ImageUtils.getLogoUrlForOmapiId(this.orderOption.omapiId, componentName);
  }

  public onEmitOrderProduct(order: Order): void {
    if (this.orderOption.term) {
      order.term = this.orderOption.term;
    }
    this.emitOrderProduct.emit(order);
  }

  onBack(): void {
    this.emitOnBack.emit();
  }

  get getCurrentLang(): string {
    return this.languageService.getCurrentLanguage().toLowerCase();
  }

  private getTextDecimalPart(price: string): string {
    const sign = this.getCurrentLang === 'fr' ? ' €' : '';
    return PriceUtils.prefixDecimalPart(price, this.getCurrentLang) + sign;
  }
}
